export function validateGreenToRedPositions(data) {
  const { retracePct, inRightDirectionPct } = data;
  if (inRightDirectionPct <= 0)
    return [false, 'Right Direction Percentage must be larger than zero.'];
  if (inRightDirectionPct < retracePct)
    return [
      false,
      'Right Direction Percentage must be larger than Retrace Percentage.',
    ];
  return [true, ''];
}
